<ag-grid-vue
  class="ag-theme-overrides"
  :theme="themeQuartz"
  :getRowId="getRowId"
  :rowData="rowData"
  :columnDefs="columnDefs"
  :pagination="isPagination"
  @cell-value-changed="onCellValueChanged"
  @cellEditingStarted="onCellEditStart"
  :paginationPageSize="paginationPageSize"
  :suppressPaginationPanel="true"
  :rowSelection="rowSelectionObj"
  @grid-ready="onGridReady"
  @sort-changed="onSortChanged"
  @selectionChanged="onSelectionChanged"
  @row-clicked="onRowClicked"
  :tooltipShowDelay="0"
  :rowDragManaged="true"
  :animateRows="true"
  :stopEditingWhenCellsLoseFocus="true"
  domLayout="autoHeight"
  @row-drag-end="onRowDragEnd"
  :icons="icons"
  :components="components"
  :localeText="{ noRowsToShow: noRowsToShowText }"
  :getRowClass="getRowClass"
  :enableCellTextSelection="enableCellTextSelection"
>
</ag-grid-vue>
